import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./style.css";

const ProjectsCard = ({ items, activeSection }) => {
  const { t } = useTranslation();

  if (!items || items.length === 0) {
    return (
      <div className="text-center py-5">
        <i className="bi bi-inbox display-1 text-muted opacity-50 mb-3"></i>
        <p className="text-muted fs-5 mb-0">{t("NoAvailable")}</p>
      </div>
    );
  }

  return (
    <div className="row g-4">
      {items.map((item, index) => (
        <div className="col-lg-4 col-md-6" key={item.id || index}>
          <div className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden card-hover">
            {item.image && (
              <div className="position-relative overflow-hidden">
                <img
                  src={item.image}
                  className="card-img-top"
                  alt={item.title}
                  style={{ height: "200px", objectFit: "cover" }}
                />
              </div>
            )}
            <div className="card-body d-flex flex-column p-4">
              <h5
                className="card-title fw-bold mb-3 text-dark"
                dangerouslySetInnerHTML={{ __html: item.title }}
              ></h5>
              <p
                className="card-text text-muted flex-grow-1 lh-base"
                dangerouslySetInnerHTML={{ __html: item.shortDesc }}
              ></p>
              <div className="mt-auto pt-3">
                <Link
                  to={`/projectsShowMore/${item.id}`}
                  className="btn btn-primary btn-card-project w-100 rounded-2 py-2 fw-medium d-flex align-items-center justify-content-center"
                >
                  {t("MoreDetails")}
                  <i className="bi bi-arrow-right ms-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectsCard;
